
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/logindetails",
      function () {
        return require("private-next-pages/my-account/logindetails.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/logindetails"])
      });
    }
  